$(function () {

    $(document).ready(function () {
        // get a handle on things
        var list = $('.ze-bigboy__list > .list');
        var listItems = $(list).children('.item');
        var listItemDescription = $('.ze-bigboy__description')
        var listItemDescriptions = $(listItemDescription).children('.content');

        // Setup -- first item is set to active on load
        listItems.first().addClass('active');
        listItemDescriptions.first().addClass('active');

        // set interval
        var autoScroll = setInterval(function () {
            var item = $(list).children('.item.active').next();

            if (item.length == 0) {
                listItems.first().click();
            }
            else {
                item.click();
            }

        }, 5000);

        // Click event -- when item is clicked, its corresponding description is displayed
        $(list).children('.item').click(function (e) {

            if (e.which) clearInterval(autoScroll);

            var clickedItem = $(this);
            var foundDescription = $(".content[data-id='" + $(clickedItem).data('id') + "']");

            if (foundDescription.length > 0) {
                $(listItems).removeClass('active');
                $(listItemDescriptions).hide();
                $(listItemDescriptions).removeClass('active');
                $(foundDescription).fadeIn(500).addClass('active');
                $(this).addClass('active');
            }
        });

        var carousel = $('.ze-bigboy .owl-carousel');

        if (carousel.length > 0) {
            carousel.owlCarousel({
                items: 3,
                loop: true,
                margin: 30,
                nav: true,
                smartSpeed: 900,
                navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
                responsive: {
                    0: {
                        items: 1
                    },
                    428: {
                        items: 2
                    },
                    768: {
                        items: 3
                    }
                }
            });
        }
    });

});